import $ from 'jquery';

const service = () => {
    let serviceMain = $(".service--main"),
        gradientStartColor = serviceMain.attr('data-gradient-scolor'),
        gradientEndColor = serviceMain.attr('data-gradient-ecolor'),
        gradientStartPercentage = serviceMain.attr('data-gradient-sper'),
        gradientEndPercentage = serviceMain.attr('data-gradient-eper');

    document.documentElement.style.setProperty('--gradient-start-color', gradientStartColor);
    document.documentElement.style.setProperty('--gradient-end-color', gradientEndColor);
    document.documentElement.style.setProperty('--gradient-start-percentage', gradientStartPercentage);
    document.documentElement.style.setProperty('--gradient-end-percentage', gradientEndPercentage);
};

export default service;